import Styles from "./BuyPremium.module.scss";
import Banner_o from "../../../../icons/screens/spotify/spotify_buy_premium_1.webp"
import Banner_t from "../../../../icons/screens/spotify/spotify_buy_premium_2.webp"
import Banner_th from "../../../../icons/screens/spotify/spotify_buy_premium_3.webp"
import Banner_f from "../../../../icons/screens/spotify/spotify_buy_premium_4.webp"
import Banner_fi from "../../../../icons/screens/spotify/spotify_buy_premium_5.webp"



const BuyPremium = () => {

    const UIImages = [
        Banner_o,
        Banner_t,
        Banner_th,
        Banner_f,
        Banner_fi

    ]


    return (
        <div className={Styles.container}>
            {
                UIImages.map((imageLink:any)=>{
                    return (
                        <img src={imageLink} key={imageLink}/>
                    )
                })
            }
        </div>
    )
}

export default BuyPremium
